import { IconBaseProps, IconType } from "@/types/icon";

export const InboxFullOutlineIcon: IconType = ({
  size = 24, // 기본 크기를 24px로 설정
  color = "text-gray-800", // 기본 색상을 text-gray-800으로 설정
  ...props
}: IconBaseProps) => {
  return (
    <svg
      className={`${color} w-[${size}px] h-[${size}px]`}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M4 13h3.439a.991.991 0 0 1 .908.6 3.978 3.978 0 0 0 7.306 0 .99.99 0 0 1 .908-.6H20M4 13v6a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-6M4 13l2-9h12l2 9M9 7h6m-7 3h8"
      />
    </svg>
  );
};
